/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const CultureHubFill = (props) => (
  <BaseSvgIcon {...props} viewBox="0 0 24 21">
    <path
      d="M5.22381 20.5931V13.0977H3.17956C2.299 13.0977 1.54885 12.788 0.929115 12.1685C0.309705 11.5488 0 10.7987 0 9.9181V7.79807C0 6.91751 0.309705 6.16736 0.929115 5.54762C1.54885 4.92821 2.299 4.61851 3.17956 4.61851H10.5234L18.3215 0V17.7162L10.5234 13.0977H7.19227V20.5931H5.22381ZM21.8042 14.544V3.17218C22.463 3.78306 22.9936 4.58504 23.3962 5.57813C23.7987 6.57122 24 7.66454 24 8.85809C24 10.0516 23.7987 11.1449 23.3962 12.138C22.9936 13.1311 22.463 13.9331 21.8042 14.544Z"
      fill="#000"
    />
  </BaseSvgIcon>
)

export default CultureHubFill
